// extracted by mini-css-extract-plugin
export default {"adminWrapper":"Personal_adminWrapper__yUifA","admin":"Personal_admin__9FpMZ"};